var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentialActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9304 6.21007L13.3304 7.89007L11.0004 5.70007V4.30007L13.3304 2.11007L16.9304 3.79007C17.3104 3.97007 17.7504 3.80007 17.9304 3.43007C18.1104 3.05007 17.9404 2.61007 17.5704 2.43007L13.6504 0.600073C13.2704 0.420073 12.8204 0.500073 12.5204 0.800074L10.7804 2.40007C10.6004 2.16007 10.3204 2.00007 10.0004 2.00007C9.45044 2.00007 9.00044 2.45007 9.00044 3.00007V4.00007H5.82044C5.34044 2.65007 3.98044 1.73007 2.40044 2.07007C1.24044 2.32007 0.250442 3.32007 0.0404424 4.50007C-0.179558 5.82007 0.500442 6.97007 1.52044 7.58007L4.08044 16.0001H1.00044V19.0001H14.0004V16.0001H10.3804L5.41044 6.77007C5.58044 6.53007 5.72044 6.28007 5.82044 6.00007H9.00044V7.00007C9.00044 7.55007 9.45044 8.00007 10.0004 8.00007C10.3204 8.00007 10.6004 7.84007 10.7804 7.60007L12.5204 9.20007C12.8204 9.50007 13.2704 9.58007 13.6504 9.40007L17.5704 7.57007C17.9504 7.39007 18.1104 6.95007 17.9304 6.57007C17.7504 6.20007 17.3104 6.03007 16.9304 6.21007ZM3.00044 6.00007C2.45044 6.00007 2.00044 5.55007 2.00044 5.00007C2.00044 4.45007 2.45044 4.00007 3.00044 4.00007C3.55044 4.00007 4.00044 4.45007 4.00044 5.00007C4.00044 5.55007 3.55044 6.00007 3.00044 6.00007Z",
    fill: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialActive);
export default __webpack_public_path__ + "static/media/ResidentialActive.77d10b9fc46e3dc028810d5e1591e817.svg";
export { ForwardRef as ReactComponent };